import mixpanel from 'mixpanel-browser';
import rootLogger from '@/utils/root-logger';

const logger = rootLogger.create('telemetry');

function Telemetry() {
  this.getMixpanelInstance = (env) => {
    const name = env.name;
    const options = {
      disable_persistence: true,
      ...env.mixpanel.options
    }
    if (!mixpanel[name]) {
      // https://mixpanel.com/help/reference/javascript-full-api-reference#mixpanel.init
      mixpanel.init(env.mixpanel.token, options || {}, name);
    }
    return mixpanel[name];
  };

  this.track = (env, event, params) => {
    logger.log('track', {event, params});
    this.getMixpanelInstance(env).track(event, params);
  };

  this.setContext = (env, context) => {
    logger.log('setContext', context);
    this.getMixpanelInstance(env).register(context);
  };

  return this;
}

const telemetry = new Telemetry();

export default telemetry;
